import { Draggable } from "@hello-pangea/dnd";
import { Box, IconButton,Tooltip, Typography } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { PropsDraggableItem } from "./types";
import CatalogOption from "../..";
import { useCatalogStoreModule } from "../../context";
import { findNodeById } from "./methods";
import { useStyles } from "./styles";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomAccordion from "../../../../../../../../../../components/accordion";
import { icons } from "../../../../../../../../../../utils/icons";
import SimpleModal from "../../../../../../../../../../components/modal/simpleModal";
import { Priority } from "../../../../../../../../../../utils/enums/priority";
import CrudModal from "../../../../../../../../../../components/modal/crudModal";
import ModalProviderComponent from "../modalProvider";
import { InputModalRef } from "../modalProvider/types";



export const DraggableItemComponent = ({ index, item, depth, rootId, parentId }: PropsDraggableItem) => {
  const { setSelectedItem, setSelectedItemRoot, assignProvider, deleteItem, setExpandedLevel, items } = useCatalogStoreModule();

  const styles = useStyles()
  const { t } = useTranslation()
  const handleExpand = () => {
    setExpandedLevel( item.id )
  };


  const foundItem = findNodeById(items, item.id);
  const isExpanded = foundItem?.expand ?? false
  const formRef = useRef<InputModalRef>(null);
  const hihgPriority: boolean = item.priority == Priority.HIGH || item.priority == Priority.URGENT


  const [modal, setModal] = useState<{
    open: boolean
    title: string
    description?: string
    confirm: () => void,
  }>({
    open: false,
    title: '',
    description: '',
    confirm: () => { },
  })

  const [crudModal, setCrudModal] = useState<{
    open: boolean
    title: string
    description?: string
    confirm: () => void,
    children: JSX.Element
  }>({
    open: false,
    title: '',
    description: '',
    confirm: () => { },
    children: <></>,
  })

  const closeModal = () => {
    setModal(prev => ({
      ...prev,
      open: false,
    }))
  }

  const closeCrudModal = () => {
    setCrudModal(prev => ({
      ...prev,
      open: false,
    }))
  }

  const openCrudModal = () => {
    setCrudModal(prev => ({
      ...prev,
      open: true,
      title: t("catalog.messages.selectProvider"),
      description: parentId
        ? t("catalog.messages.assignProviderSubCategory")
        : t("catalog.messages.assignProviders"),
    }))
  }

  const handleDelete = () => {
    setModal(prev => ({
      ...prev,
      open: true,
      title: t('optionGroup.modal.confirmation'),
      description: t('optionGroup.modal.deleteItem'),
      confirm: () => {
        deleteItem(item.id)
        closeModal()
      },
    }))
  }

  const handleAssignProvider = () => {
    assignProvider(formRef.current?.getProviderId(), parentId ? parentId : null, item.id);
    closeCrudModal();
  }

  const handleSelectItem = () => {
    if (parentId) {
      setSelectedItem(parentId, item)
    } else {
      setSelectedItemRoot(item)
    }
  }


  return (
    <>
      <Draggable key={item.id} draggableId={item.id} index={index}>
        {(provided, snapshot) => (
          <Box
            key={item.id}
            ref={provided.innerRef}
            {...provided.draggableProps}
            sx={styles.container(snapshot.isDragging, depth % 2 == 0)}
          >
            <CustomAccordion
              title={
                <Box
                  sx={styles.headerCustom(depth % 2 === 0)}
                >
                  {/* Handler + texto */}
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      {...provided.dragHandleProps}
                      sx={{
                        cursor: "grab",
                        color: "grey.500",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <DragIndicatorIcon />
                    </Box>
                    <Typography fontWeight="bold">{item.label}</Typography>
                  </Box>

                  {/* Iconos de acción */}
                  <Box sx={styles.iconContainer}>
                    {item.level == 2 &&
                      <Typography sx={styles.status(hihgPriority)}>{t(`catalog.priority.${item.priority}`)}</Typography>
                    }

                    {(item.level == 1 || item.level == 2) &&
                      <Tooltip title={t('ToolTips.provider')}>
                        <IconButton onClick={openCrudModal}>{icons('user')} </IconButton>
                      </Tooltip>
                    }

                    {item.isEditable &&
                      <Tooltip title={t('ToolTips.edit')}>
                        <IconButton size="small" onClick={handleSelectItem}>
                          {icons('edit')}
                        </IconButton>
                      </Tooltip>
                    }

                    {item.isEditable &&
                      <Tooltip title={t('ToolTips.delete')}>
                        <IconButton size="small" onClick={handleDelete}>
                          {icons('simple-close')}
                        </IconButton>
                      </Tooltip>
                    }

                    {!item.textInput && <Tooltip title={isExpanded ? t('ToolTips.collapse') : t('ToolTips.expand')}>
                      <IconButton size="small" onClick={handleExpand} sx={styles.rotate(isExpanded)}>
                        {icons('arrow-down')}
                      </IconButton>
                    </Tooltip>}
                  </Box>
                </Box>
              }
              description={
                <CatalogOption
                  parentId={item.id}
                  children={!isExpanded ? [] : item.children || []}
                  depth={(depth ?? 0) + 1}
                  rootId={parentId ? rootId : item.id}
                  level={item.level + 1}
                  id={item.id}
                  subCatalogId={item.subcatalog}
                />}
              expandIcon={null}
              expanded={isExpanded}
            />
          </Box>
        )}


      </Draggable>
      <SimpleModal
        open={!!modal.open}
        next={modal.confirm}
        back={closeModal}
        close={closeModal}
        description={modal.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        title={modal.title}
        loadingButton={false}
      />

      <CrudModal
        disable={false/* state.providerValue?.id==0 */}
        sx={styles.crudModal}
        description={crudModal.description ?? ""}
        open={crudModal.open ?? false}
        close={closeCrudModal}
        title={crudModal.title ?? ""}
        buttonText={t('catalog.button.assign')}
        children={<ModalProviderComponent providerId={item.provider} ref={formRef} />}
        next={handleAssignProvider}
      />
    </>
  );
};
